<template>
  <div class="hzc-discuss">
    <div class="mask" @click="closeIndustrial"></div>
    <div class="content">
      <p class="banner-title">{{ chainTitle }}</p>
      <div class="data1">{{ data1['druidParamName'] }} <p style="color: #2AD3DA">{{ data1['price'] }}</p></div>
      <div class="data2">{{ `${data2['druidParamName']}:` }} <p style="color: #2AD3DA">{{ data2['price'] }}</p>
      </div>
      <div class="data3">{{ `${data3['druidParamName']}:` }} <p style="color: #2AD3DA">{{ data3['price'] }}</p>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: [
    'chainTitle',
    'data1',
    'data2',
    'data3',
    'data4',
  ],
  data() {
    return {}
  },
  created() {
  },
  beforeCreate() {
    document.querySelector('body').setAttribute('style', 'overflow:hidden')
  },
  beforeDestroy() {
    document.querySelector('body').removeAttribute('style')
  },
  methods: {
    /**
     * 关闭
     */
    closeIndustrial(val) {
      this.$emit('closeIndustrialCh', val);
    },
  }
}
</script>

<style lang="less" scoped>
.hzc-discuss {
  z-index: 101;
  width: 980px;
  height: 544px;
  background-color: #fff;

  .confirm {
    position: fixed;
    right: 10px;
    top: 10px;
    z-index: 110;
    width: 50px;
    cursor: pointer;
  }

  .mask {
    z-index: 100;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
  }

  .content {
    width: 982px;
    height: 547px;
    display: inline-block;
    background: url("../../assets/home/qingnengBigBanner.png");
    background-size: 100% 100%;
    color: #fff;
    z-index: 101;
    position: relative;

    img {
      width: 980px;
      height: 544px;
    }

    .banner-title {
      position: absolute;
      font-size: 16px;
      top: 22px;
      left: 215px;
      color: #0E743F;
    }

    .data1 {
      font-size: 12px;
      position: absolute;
      top: 309px;
      left: 162px;
      width: 106px;
      height: 70px;
      color: #293E51;
      text-align: center;
    }

    .data2 {
      font-size: 12px;
      line-height: 14px;
      position: absolute;
      top: 97px;
      left: 486px;
      width: 106px;
      height: 70px;
      color: #293E51;
      text-align: center;
    }

    .data3 {
      font-size: 12px;
      line-height: 15px;
      position: absolute;
      top: 221px;
      left: 484px;
      width: 106px;
      height: 70px;
      color: #293E51;
      text-align: center;
    }

  }

  .redColor {
    color: #FF6969;
  }

  .greenColor {
    color: #43E97B;
  }
}
</style>
